import Parse, {
  ParseAddress,
  AREA,
  Utils
} from './parse';

if (window) {
  window.AddressParse = Parse;
}
Parse.Utils = Utils;
Parse.AREA = AREA;
Parse.ParseAddress = ParseAddress;

export default Parse



// WEBPACK FOOTER //
// ./~/vue-xpc/src/libs/address/index.js